import { render, staticRenderFns } from "./ShowDocumentation.vue?vue&type=template&id=4e5af72c&"
import script from "./ShowDocumentation.vue?vue&type=script&lang=js&"
export * from "./ShowDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ShowDocumentation.vue?vue&type=style&index=0&id=4e5af72c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports